// apps/merchant-v3/src/lib/format/storageUrl.ts
//
// Phase 6 debug B5 — resolve relative /storage/* URLs against the API
// host so the merchant-v3.printway.work origin doesn't try to serve
// uploaded assets itself (404). BE persists avatarUrl as a relative
// `/storage/avatars/<id>.<ext>` path because storage-paths.ts defaults
// to relative; this helper prefixes it with VITE_API_BASE_URL at render
// time so existing rows do not need a DB migration.
//
// vg-binding: DEBUG:B5

import { API_BASE_URL } from '@/lib/api/client';

export function resolveStorageUrl(
  raw: string | null | undefined,
): string | undefined {
  if (!raw) return undefined;
  if (/^https?:\/\//.test(raw)) return raw;
  if (raw.startsWith('/storage/')) {
    return (API_BASE_URL || '') + raw;
  }
  return raw;
}

// dbg-20260629-merchprod — inline placeholder shown when a product has no
// mockup or its image fails to load. Data-URI SVG so there is no asset
// round-trip and no second broken-image request. Neutral slate card with a
// centred image glyph matching the palette used on the product cards.
export const PRODUCT_IMAGE_PLACEHOLDER =
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 200 200">' +
      '<rect width="200" height="200" fill="#f1f5f9"/>' +
      '<g fill="none" stroke="#cbd5e1" stroke-width="6" stroke-linejoin="round">' +
      '<rect x="55" y="62" width="90" height="76" rx="6"/>' +
      '<path d="M55 118l26-24 20 18 24-28 20 22" stroke-linecap="round"/>' +
      '</g>' +
      '<circle cx="86" cy="88" r="9" fill="#cbd5e1"/>' +
      '</svg>',
  );
